module.exports = "input:disabled, textarea:disabled{\r\n    color:black !important;\r\n}\r\n\r\n/*\r\n.userInputClass .ui-state-disabled, .ui-widget:disabled{\r\n    opacity: 0.80 !important;\r\n}*/\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/user_dlg.component.css
// module id = ./src/app/component/user_dlg.component.css
// module chunks = main